import { ClinicPaymentQuery, ListResult, Payment } from '../types';
import { USE_MOCK_PAYMENTS } from '../constants/buyer-portal';
import { paymentMock } from '../mocks/paymentMock';
import { clinicHttp } from './http';
import { ENDPOINTS } from './endpoints';
import {
  BuyerPaymentDtoBackend,
  InvoiceDtoBackend,
  mapPaymentDto,
  renderInvoiceAsText,
} from './paymentMapper';

export type PaymentService = {
  list: (query?: ClinicPaymentQuery) => Promise<ListResult<Payment>>;
  detail: (paymentId: string) => Promise<Payment>;
  invoiceText: (orderId: string) => Promise<string>;
};

type BackendListResult = {
  items: BuyerPaymentDtoBackend[] | null;
  skip: number;
  take: number;
  total: number;
};

const realPaymentService: PaymentService = {
  list: async (query = {}) => {
    const res = await clinicHttp.get<BackendListResult>(ENDPOINTS.BUYER.PAYMENTS, {
      params: query,
    });
    return {
      items: (res.data.items ?? []).map(mapPaymentDto),
      skip: res.data.skip,
      take: res.data.take,
      total: res.data.total,
    };
  },
  detail: async (paymentId) => {
    const res = await clinicHttp.get<BuyerPaymentDtoBackend>(
      ENDPOINTS.BUYER.PAYMENT_DETAIL(paymentId),
    );
    return mapPaymentDto(res.data);
  },
  invoiceText: async (orderId) => {
    const res = await clinicHttp.get<InvoiceDtoBackend>(ENDPOINTS.BUYER.INVOICE(orderId));
    return renderInvoiceAsText(res.data);
  },
};

export const paymentService: PaymentService = USE_MOCK_PAYMENTS
  ? paymentMock
  : realPaymentService;
